import SignUpPage from "@/pages/SignUp/SignUpPage/SignUpPage";

import { renderPageComponent } from '@/utils/react_page';
renderPageComponent(SignUpPage);